import { Headphones, Lock, ShieldCheck, Tag } from 'lucide-react';
import { PHONE, SITE_NAME } from '../../constants/site';

const STEPS = ['Review', 'Contact', 'Travelers', 'Confirm'];

export function BookingProgress({ active = 1, light = false }) {
  return (
    <ol
      className={`booking-progress${light ? ' booking-progress--light' : ''}`}
      aria-label="Booking steps"
    >
      {STEPS.map((label, i) => {
        const step = i + 1;
        const state = step < active ? 'done' : step === active ? 'active' : '';
        return (
          <li key={label} className={`booking-progress__step ${state}`}>
            <span className="booking-progress__num">{step}</span>
            <span className="booking-progress__label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export function BookingBenefitsBar() {
  const items = [
    { Icon: Headphones, text: '24/7 live support' },
    { Icon: Lock, text: 'Secure SSL checkout' },
    { Icon: ShieldCheck, text: 'Trusted travel partner' },
    { Icon: Tag, text: 'Transparent pricing' },
  ];

  return (
    <div className="booking-benefits">
      {items.map(({ Icon, text }) => (
        <div key={text} className="booking-benefits__item">
          <Icon size={18} aria-hidden />
          <span>{text}</span>
        </div>
      ))}
    </div>
  );
}

export function BookingHelpCards() {
  return (
    <div className="booking-help-cards">
      <div className="booking-help-card">
        <h3>Need help booking?</h3>
        <p>Our travel experts are available around the clock to complete your reservation by phone.</p>
        <a href={`tel:${PHONE.replace(/[^\d+]/g, '')}`} className="booking-help-card__cta">
          Call {PHONE}
        </a>
      </div>
      <div className="booking-help-card">
        <h3>What happens next?</h3>
        <p>
          After you submit, a {SITE_NAME} agent will verify availability and contact you to confirm
          payment and send your itinerary.
        </p>
      </div>
      <div className="booking-help-card booking-help-card--accent">
        <h3>Flexible changes</h3>
        <p>
          Change or cancel requests can be handled by our support team subject to airline or
          supplier rules and fees.
        </p>
      </div>
    </div>
  );
}

export function PaymentTrustBadges() {
  return (
    <div className="booking-payment-badges">
      <span className="booking-payment-badges__label">We accept</span>
      <div className="booking-payment-badges__logos">
        <span>Visa</span>
        <span>Mastercard</span>
        <span>Amex</span>
        <span>Discover</span>
      </div>
      <p className="booking-payment-badges__note">
        Card details are transmitted over a secure connection. {SITE_NAME} does not store your full
        card number on our servers.
      </p>
    </div>
  );
}
